import { FaTable, FaCalendarAlt, FaUserEdit, FaChevronDown, FaChevronRight, FaChevronLeft, FaChevronUp, FaCheck, FaPrint, FaExchangeAlt, FaHourglass, FaUser, FaRegClock, FaSearch, FaFilter, FaChalkboardTeacher, FaFileAlt, FaSchool } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { FaTableList, FaPlus, FaPencil, FaClock } from "react-icons/fa6";
import { GrSchedules } from "react-icons/gr";
import { FaFlagCheckered, FaMap } from "react-icons/fa";
import { MdDelete, MdRemove, MdSend, MdClose, MdAppRegistration, MdOutlineSort } from "react-icons/md";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { PiTildeBold } from "react-icons/pi";
import { RiAdminFill } from "react-icons/ri";
import { BiSolidError } from "react-icons/bi";
import { MdOutlineDataSaverOff, MdAdsClick } from "react-icons/md";
export default function UI_Icon({
    className,
    Name
}) {
    const Registry = {
        Table: FaTable,
        Calendar: FaCalendarAlt,
        List: FaTableList,
        User: FaUser,
        User_Edit: FaUserEdit,
        Schedule: GrSchedules,
        Finish: FaFlagCheckered,
        Add: FaPlus,
        Delete: MdDelete,
        Close: MdClose,
        Remove: MdRemove,
        Map: FaMap,
        Send: MdSend,
        Arrow_Up: FaChevronUp,
        Arrow_Down: FaChevronDown,
        Arrow_Left: FaChevronLeft,
        Arrow_Right: FaChevronRight,
        Check: FaCheck,
        Cross: ImCross,
        Print: FaPrint,
        Edit: FaPencil,
        Manage: MdAppRegistration,
        Reschedule: FaClock,
        Propose: FaExchangeAlt,
        Pending: FaHourglass,
        See: IoEye,
        Unsee: IoEyeOff,
        Clock: FaRegClock,
        Search: FaSearch,
        Filter: FaFilter,
        Sort: MdOutlineSort,
        Partial: PiTildeBold,
        Teacher: FaChalkboardTeacher,
        Administrator: RiAdminFill,
        Document: FaFileAlt,
        Error: BiSolidError,
        School: FaSchool,
        Saving: MdOutlineDataSaverOff,
        Action: MdAdsClick 
    }
    const IconComponent = Registry[Name];
    return <IconComponent className={className ? className : undefined}/>
}